import { connect } from 'react-redux';
import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { api, apiUtils } from 'app/services';
import * as selectors from 'app/selectors';
import { renderKBInput, renderKBTextarea, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { showApiError } from 'utils/feedback';
import {
usersActions,
apiCallFailure,
orgUserActions,
successState } from
'app/actions';
import {
KBRadio,
KBForm,
KBFormError,
KBButton,
KBPopover,
KBImageCropperInput,
KBAvatar } from
'components';
import config from 'app/config';


var GroupSetBaseAddFacilities = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.addProduct = this.addProduct.bind(this);this.loadingCallBack = this.loadingCallBack.bind(this);this.UploadFailureCallBack = this.UploadFailureCallBack.bind(this);}getInitialState()
  {
    return {
      loading: false };

  }componentDidMount()

  {
    const {
      fields: { id, name, description, image },
      type,
      product } =
    this.props;
    if (type === 'edit') {
      id.onChange(product.id);
      description.onChange(product.description);
      image.onChange(product.image);
      name.onChange(product.name);
    }
  }addProduct(

  model) {
    const { callBack } = this.props;
    callBack && callBack(model);
  }loadingCallBack(

  loading) {
    this.setState({ loading });
  }UploadFailureCallBack(

  msg) {
    if (msg) {
      showApiError('上传失败', msg);
    }
  }render()


  {
    const {
      fields: { id, name, description, image },
      handleSubmit,
      type,
      submitting,
      groupId } =
    this.props;
    const { loading } = this.state;
    return (
      <KBForm
      type="reduxForm"
      onSubmit={handleSubmit(this.addProduct)}>

        <header className="kb-form-header">
          <h2 className="header-title">
            {type === 'create' ? '添加' : '编辑'}社区介绍
          </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container">
          <div className='kb-row'>
            <Field name="name" component={renderKBInput}
            title="社区名称"

            className="kb-form-group kb-div-48 kb-form-alone"
            isRequiredR={true} />

          </div>
          <div className="kb-row">
            <fieldset className="fieldset">
              <legend>社区图片</legend>
              <div>
                <KBImageCropperInput
                // callback={this.callback}
                // failureCallBack={this.failureCallBack}
                field={image}
                style={{ display: 'inline-block' }}
                type={`groups/${groupId}`}
                loadingCallBack={this.loadingCallBack}
                imageSize={1024}
                failureCallBack={this.UploadFailureCallBack}
                width={225}
                height={150}
                aspect={1125 / 750}
                previewBorderRadius={0}
                accept=".png,.jpg,.jpeg"
                isPublic>

                  <div className="upload-portrait">
                    <button
                    className="bordered-btn"
                    type="button"
                    style={{ marginLeft: 0, marginBottom: 20, width: 100 }}>

                      {loading ?
                      '上传中...' :
                      image.value ?
                      '上传新图片' :
                      '上传图片'}
                    </button>
                    <br />
                    {image.value &&
                    <KBAvatar
                    imgSize={{ width: 225, height: 150 }}
                    user={{ avatar: image.value }}
                    imgStyle={{ marginLeft: 0, verticalAlign: 'middle', borderRadius: 150 }}
                    style={{ display: 'inline-block', marginLeft: 0 }} />}


                  </div>
                </KBImageCropperInput>
              </div>
            </fieldset>
          </div>
          <div className="kb-row">
            <Field name="description" component={renderKBTextarea}
            className="kb-form-group kb-form-c18 kb-form-alone"
            isRequired={true}

            title="描述" />

          </div>
        </div>
        <div className="kb-row fixed-form-btn">
          <span className="cancel-btn" onClick={KBPopover.close}>
            取消
          </span>
          <KBButton
          className="certain-btn"
          type="submit"
          style={{ marginLeft: 20 }}
          submitting={submitting}>

            {type === 'create' ? '添加' : '保存'}
          </KBButton>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = '请输入社区名称';
  }
  if (!values.description) {
    errors.description = '请填写描述';
  }
  if (!values.image) {
    errors.image = '请上传图片';
  }
  return errors;
};

const LEGACY_FORM_FIELDS = [
  "id",
  "name",
  "description",
  "image"
];

const formConfig = {
  form: 'GroupSetBaseAddProductForm',
  validate: validate,
  touchOnBlur: false };


GroupSetBaseAddFacilities = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('GroupSetBaseAddProductForm', LEGACY_FORM_FIELDS)(GroupSetBaseAddFacilities)));

export default GroupSetBaseAddFacilities;
